import React from 'react'
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded'
import NewspaperRoundedIcon from '@mui/icons-material/NewspaperRounded'
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded'
import BallotRoundedIcon from '@mui/icons-material/BallotRounded'
import EventRoundedIcon from '@mui/icons-material/EventRounded'
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded'

const PAGE_INFO = {
    '/register/': {
        title: 'Registro',
        menu: false,
    },
    '/admin/announce/create/': {
        title: 'Nuevo Anuncio',
        menu: 0,
    },
    '/admin/meeting/create/': {
        title: 'Nueva Junta',
        menu: 1,
    },
    '/admin/community/create/': {
        title: 'Asistente Nueva Comunidad',
        menu: 5,
    },
    '/admin/community/select-create/': {
        title: 'Elige Método',
        menu: 5,
    },
    '/admin/community/manual-create/': {
        title: 'Creación Manual',
        menu: 5,
    },
    '/admin/community/success/': {
        title: 'Comunidad Creada',
        menu: 5,
    },
    '/admin/community/edit/': {
        title: 'Editar Comunidad',
        menu: 5,
    },
    '/admin/community/facility/edit/': {
        title: 'Editar Instalaciones',
        menu: 5,
    },
    '/neighbour/user-profile/': {
        title: 'Mi Perfil',
        icon: <AccountCircleRoundedIcon />,
        menu: false,
    },
    '/neighbour/community/home/': {
        icon: <HomeWorkRoundedIcon />,
        title: 'Mis Comunidades',
        menu: 5,
    },
    '/neighbour/dashboard/announces/': {
        icon: <NewspaperRoundedIcon />,
        title: 'Tablón de anuncios',
        menu: 0,
    },
    '/neighbour/dashboard/meetings/': {
        icon: <BallotRoundedIcon />,
        title: 'Juntas',
        menu: 1,
    },
    '/neighbour/reservation/home/': {
        icon: <EventRoundedIcon />,
        title: 'Reservas',
        menu: 2,
    },
    '/neighbour/reservation/create/': {
        icon: <EventRoundedIcon />,
        title: 'Reserva de instalación',
        menu: 2,
    },
    '/neighbour/delivery/home/': {
        icon: <LocalShippingRoundedIcon />,
        title: 'Paquetería',
        menu: 3,
    },
    '/neighbour/ticket/home/': {
        icon: <WarningRoundedIcon />,
        title: 'Incidencias',
        menu: 4,
    },
    '/legal': {
        title: 'Aviso Legal',
        menu: false,
    },
    '/privacy': {
        title: 'Política de Privacidad',
        menu: false,
    },
    '/cookies': {
        title: 'Política de Cookies',
        menu: false,
    },
    '/fee/': {
        title: 'Tarifas',
        menu: 0,
    },
    '/work/': {
        title: 'Empleo',
        menu: 1,
    },
    '/videos/': {
        title: 'Videos',
        menu: 2,
    },
    '/': {
        title: '',
        menu: false,
    },
}

const MENU_ITEMS = [
    '/neighbour/dashboard/announces/',
    '/neighbour/dashboard/meetings/',
    '/neighbour/reservation/home/',
    '/neighbour/delivery/home/',
    '/neighbour/ticket/home/',
    '/neighbour/community/home/',
]

const MENU_LANDING_ITEMS = ['/fee/', '/work/', '/videos/']

export { MENU_ITEMS, PAGE_INFO, MENU_LANDING_ITEMS }
